import { useContext } from "react";
import { DragAndDropContext } from "~/providers/DragAndDropProvider";

export const useDragAndDropContext = () => {
  return useContext(DragAndDropContext);
};
